import { render, staticRenderFns } from "./HomePageMediaQuotes.vue?vue&type=template&id=1dea640b&scoped=true&"
import script from "./HomePageMediaQuotes.vue?vue&type=script&lang=js&"
export * from "./HomePageMediaQuotes.vue?vue&type=script&lang=js&"
import style0 from "./HomePageMediaQuotes.vue?vue&type=style&index=0&id=1dea640b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea640b",
  null
  
)

export default component.exports